<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item><i class="el-icon-lx-file"></i> Svn相关</el-breadcrumb-item>
                <el-breadcrumb-item>备份信息</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container" style="min-width: 900px">

            <el-table
                :data="tableData"
                border
                class="table"
                type="index"
                v-loading="loading"
                element-loading-text="正在加载中"
                ref="multipleTable"
                :row-class-name="tableRowClassName"
                :cell-style="{ textAlign: 'center' }"
                :header-cell-style="{textAlign: 'center'}"
                header-cell-class-name="table-header"
            >
                <el-table-column prop="id" label="ID" align="center" width="275"></el-table-column>
                <el-table-column prop="userId" label="用户ID"></el-table-column>
                <el-table-column prop="name" label="文件名称"></el-table-column>
                <el-table-column prop="createTime" label="备份时间" :formatter="dateFormat"></el-table-column>

                <el-table-column label="操作" width="200" align="center">
                    <template slot-scope="{row}">
                        <el-button
                            type="text"
                            icon="el-icon-lx-down"
                            @click="ProjectInfoFileInfo(row.path, row.name)"
                        >下载</el-button>
                        <el-button
                            type="text"
                            icon="el-icon-delete"
                            class="red"
                            @click="handleDelete(row.id, row.path, row.index)"
                        >删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination
                    background
                    layout="total, prev, pager, next"
                    :current-page="query.pageIndex"
                    :page-size="pageSize"
                    :total="pageTotal"
                    @current-change="handlePageChange"
                ></el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import moment from 'moment' 
import http from '../../common/Common.vue'
export default {
    name: 'basetable',
    data() {
        return {
            query: {
                pageIndex: 1, //页码
            },
            loading: true,
            tableData: [], //el-table集合
            pageTotal: 0,  //总数据量
            pageSize: 0,  //单页数据量
            projects: [], //下拉框集合
        };
    },
    created() {

        var x =this
        setTimeout(() =>{
            x.getData(1);
            
        }, 300);

    },
    activated(){
        this.getData(1);
    },
    components: {

    },
    methods: {

        //分页获取所有数据
        //pageNum页数，   projectId 下拉框分类，  projectName 搜索框模糊查询
        getData (pageNum) {

            if (pageNum == undefined) pageNum = 1;

            let data = {'pageNum' : pageNum, 'projectId' : '0e85ea5ac76a6535bd29859c8bb10f3f', 'fileName' : 'NULL', 'isTest' : 1}

            axios.post(http.httpUrl + 'findPageVoFileInfo', data, {
                headers: {
                    'token': localStorage.getItem('token')
                }
            }).then((res) => {
                if (res.data.code == 200) {
                    this.tableData = res.data.data.records
                    this.pageTotal = res.data.data.total
                    this.pageSize = res.data.data.size
                } else {
                    this.$message.error(res.data.message)
                }

                this.loading = false

            }).catch (error =>{
                console.log (error)
            })
            
        },

        // 分页导航
        handlePageChange (val) {
            this.$set(this.query, "pageIndex", val)
            this.getData (val)
        },

        //el-Tbale 显示时间格式
        dateFormat (row, column) {
            let date = row[column.property]

            if (date == undefined) return ''

            return moment(date).format("YYYY-MM-DD HH:mm:ss")
        },

        //文件下载
        ProjectInfoFileInfo (path, name) {
            let data = {"path" : path}
            
            let url = http.httpUrl 
            if (this.query.formalOrTest == 0) url = http.httpFormalUploadUrl

            axios.post (url + '/ProjectInfoFile_vue', data, {
                'responseType': 'blob',
                headers: {
                    'token' : localStorage.getItem('token')
                }
                 
                }).then ((res) =>{
                let url = window.URL.createObjectURL(new Blob([res.data]));
                let link = document.createElement("a");
                link.style.display = "none";
                link.href = url;
                link.setAttribute("ProjectInfo", name); //指定下载后的文件名，防跳转
                document.body.appendChild(link);
                link.click();
            }).catch((err) =>{
                this.$message.error(err.message)
            })
        },

        // 删除操作
        handleDelete(id, index) {
            // 二次确认删除
            this.$confirm('确定要删除吗？', '提示', {
                type: 'warning'
            }).then(() => {

                let data = {"id": id, "isTest": 1}

                let url = http.httpUrl
                if (this.query.formalOrTest == 0) url = http.httpFormalUploadUrl
                
                axios.post (url + '/delFileInfo', data, {
                    headers: {
                        'token': localStorage.getItem('token')
                    }
                }).then ((res) => {
                    if (res.data.code == 200) {
                        setTimeout(() => {
                            this.getData (1, this.query.projectId, this.query.name, this.query.formalOrTest)
                        }, 200);

                        this.$message.success(res.data.message)
                    } else {
                        this.$message.error(res.data.message)
                    }
                })
            })
        },
        
        //把每一行的索引放进row
        tableRowClassName({row, rowIndex}) {
            row.index = rowIndex
        }

    }
};
</script>

<style scoped>
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    width: 300px;
    display: inline-block;
}
.table {
    width: 100%;
    font-size: 14px;
    border-radius: 5px;
}
.red {
    color: #ff0000;
}
.mr10 {
    margin-right: 10px;
}
.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}
</style>
